import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IUserCertificate,
  IGetUserCertificatesParams,
  IPostUserCertificateParams,
} from '@network/models/user-certificate.model'

export class UserCertificatesApi {
  constructor(private axios: AxiosService) {}

  getUserCertificates = async (params?: IGetUserCertificatesParams) => {
    const response = await this.axios.get<IPayload<IUserCertificate[]>>(
      Endpoints.getUserCertificates,
      params,
    )
    return response
  }

  getUserCertificate = async (
    id: number,
    params?: IGetUserCertificatesParams,
  ) => {
    const response = await this.axios.get<IPayload<IUserCertificate>>(
      Endpoints.getUserCertificate(id),
      params,
    )
    return response
  }

  postUserCertificate = async (params: IPostUserCertificateParams) => {
    const response = await this.axios.post<IPayload<IUserCertificate>>(
      Endpoints.postUserCertificate,
      params,
    )
    return response
  }

  deleteUserCertificate = async (id: number) => {
    const response = await this.axios.delete<{}>(
      Endpoints.deleteUserCertificate(id),
    )
    return response
  }
}
